module.exports = __webpack_public_path__ + "static/media/people-24px.f36522c4.svg";